
  import Icon from '../../../common/Icon'

  export default {
    name: 'AccountAlert',
    components: { Icon },
    props: {
      config: {
        type: Object,
        default: () => {
          return {
            show: true,
            icon_name: 'info-icon',
            icon_classes: '',
            title: 'Had an account already?',
            copy: 'Use the same email as before to create a new account and we’ll reload your Reward Points!',
            enter_animation: 'animate__animated animate__slideInRight',
            leave_animation: 'animate__animated animate__slideOutRight',
            leave_timeout: 7000,
          }
        }
      }
    },
    data() {
      return {
        showAlert: false,
      }
    },
    mounted() {
      this.showAlert = this.config ? this.config.show : false

      if (this.config && this.config.leave_timeout) {
        setTimeout(() => {
          this.showAlert = false
        }, this.config.leave_timeout);
      }
    },
  }
